import React from 'react';
import css from './iconReviewSearchPage.module.css';
import { FormattedMessage } from '../../../../../util/reactIntl';

const IconReviewSearchPage = ({
  averageRating,
  classNameContainer,
  showDot,
  textColor, // white or black or null
  showReviewsNumber,
  reviewsNumber,
  decimals = 2,
  isImpactExperience = false,
  showNewOnSocialbnbWhenNoReviews = false,
  newOnSocialbnbMessageId = 'SearchListingCard.newOnSocialbnbShort',
  newOnSocialbnbBadgeClassName = '',
}) => {
  const numericRating = Number(averageRating);
  const safeDecimals = Number.isInteger(decimals) && decimals >= 0 ? decimals : 2;
  const containerClassName = classNameContainer
    ? `${css.starContainer} ${css[classNameContainer]}`
    : css.starContainer;
  const starFillColor = numericRating > 0.1 ? '#1C7881' : '#FFF';

  const getTextClassName = () => {
    switch (textColor) {
      case 'white':
        return css.whiteText;
      case 'black':
        return css.blackText;
      default:
        return css.starReviews;
    }
  };

  const hasNoRating =
    averageRating == 0 || averageRating === null || averageRating === undefined;

  if (hasNoRating) {
    if (isImpactExperience && showNewOnSocialbnbWhenNoReviews) {
      const badgeClass = [css.newOnSocialbnbBadge, newOnSocialbnbBadgeClassName]
        .filter(Boolean)
        .join(' ');
      return (
        <div className={containerClassName}>
          <span className={badgeClass}>
            <svg
              className={css.newOnSocialbnbSparkle}
              viewBox="0 0 64 64"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              stroke="currentColor"
              strokeWidth="3"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
              focusable="false"
            >
              <path d="M30,52.16c.81-2.07,7.06-17,19.76-19.86a.09.09,0,0,0,0-.18c-2.14-.86-15.22-6.57-19.38-20.26a.09.09,0,0,0-.18,0c-.51,2.27-3.94,14.43-20,20a.1.1,0,0,0,0,.19c2.24.38,13.48,3.14,19.62,20.15A.1.1,0,0,0,30,52.16Z" />
              <path d="M48.79,25.08c.29-.74,2.52-6.07,7.06-7.09a0,0,0,0,0,0-.07c-.76-.3-5.43-2.34-6.92-7.23a0,0,0,0,0-.07,0c-.18.82-1.4,5.16-7.14,7.13a0,0,0,0,0,0,.07c.8.14,4.81,1.12,7,7.2A0,0,0,0,0,48.79,25.08Z" />
            </svg>
            <FormattedMessage id={newOnSocialbnbMessageId} />
          </span>
        </div>
      );
    }
    return <></>;
  }
  const intelFormattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: safeDecimals,
    maximumFractionDigits: safeDecimals,
  }).format(isNaN(numericRating) ? 0 : numericRating);

  return (
    <div className={containerClassName}>
      <svg
        className={css.star}
        width="14"
        height="14"
        viewBox="0 0 22 22"
        xmlns="http://www.w3.org/2000/svg"
        style={{ zIndex: 0 }}
      >
        <path
          d="M10 16.7111L16.18 20.7931L14.54 13.0997L20 7.92327L12.81 7.2557L10 0L7.19 7.2557L0 7.92327L5.46 13.0997L3.82 20.7931L10 16.7111Z"
          fill={starFillColor}
          className={textColor === 'white' ? css.whiteStroke : css.starPath}
        />
      </svg>
      <p className={getTextClassName()}>{intelFormattedNumber}</p>
      {showDot && <span className={css.starReviews}>&bull;</span>}
      {!showReviewsNumber && reviewsNumber > 0 && <p>({reviewsNumber})</p>}
    </div>
  );
};

export default IconReviewSearchPage;
